import {
  FormBody,
  FormContentContainer,
  FormHeader,
  FullScreenLoader,
} from "../../../components";
import { useEffect } from "react";
import { useGetClaveUnicaUrl } from "@hooks/useGetClaveUnicaUrl";

interface Props {
  requestId: string;
}

export const ClaveUnicaLogin: React.FC<Props> = ({ requestId }) => {
  const {
    getClaveUnicaUrlMutation: { mutate: getClaveUnicaUrl },
  } = useGetClaveUnicaUrl();
  useEffect(() => {
    getClaveUnicaUrl({ requestId });
  }, [requestId, getClaveUnicaUrl]);
  return (
    <>
      <FormHeader />
      <FormContentContainer flex={1} disableGutters>
        <FormBody justifyContent="center">
          <FullScreenLoader title={"Iniciando sesión con Clave única"} />
        </FormBody>
      </FormContentContainer>
    </>
  );
};
